import { isProduction, deploymentTier } from '../../data/constants.ts';
import { AsApp } from '../as-app/index.ts';
import { internalData } from '../../store/store.ts';
import { useShadow, useShadowStyle } from '../../util/wcUtil.ts';
import styleText from './as-footer.css?raw';
import { asApp } from '../../util/singletons.ts';

const ALWAYS_DETAILED = true

class AsVersionTag extends HTMLElement{
  static readonly tag = 'as-version-tag' as const;

  versions:{[key:string]:string|undefined}={
    app:undefined ,
    components:undefined,
    trcad:undefined,
    trcadScript:undefined
  }
  removeEnvEffect:(()=>void)|undefined
  async getVersions(){
    const appEl = asApp();
    const result = await appEl?.getVersions?.();
    this.versions.app = result?.app;
    this.versions.components = result?.components;
    this.versions.trcad = result?.trCad;
    this.versions.trcadScript = result?.trCadScript;
  }

  get html(){
    const detailedVersions = `
        | <as-text id="components-version" dict-key="footer.version.components" default-text="ASC v${this.versions.components ?? '?.?.?'}"></as-text>
        | <as-text id="script-version" dict-key="footer.version.script" default-text="script v${this.versions.trcadScript ?? '?.?.?'}"></as-text>
        | <as-text id="trcad-version" dict-key="footer.version.trcad" default-text="trCAD v${this.versions.trcad ?? '?.?.?'}"></as-text>`
    return /*html*/`
      <span id="version-tags">
        <as-text id="app-version" dict-key="footer.version.app" default-text="app v${this.versions.app ?? '?.?.?'}"></as-text>
        ${internalData.appEnv === 'grabcad' ? '<as-text id="grabcad-marker" dict-key="footer.version.grabcad" default-text="GC"></as-text>' : ''}
        ${isProduction ? '' : `<as-text id="env-tag" dict-key="footer.version.env" default-text="(${deploymentTier})"></as-text>`}
        ${ ALWAYS_DETAILED
          ? detailedVersions
          : `${ isProduction
            ? ''
            : detailedVersions  }`
        }

      </span>
  `
  }
  redraw(){
    if(this.shadowRoot){
      this.shadowRoot.innerHTML = this.html
      this.shadowRoot.querySelector('#app-version')?.setAttribute('vars', JSON.stringify([this.versions.app ?? '?.?.?']))
      this.shadowRoot.querySelector('#env-tag')?.setAttribute('vars', JSON.stringify([deploymentTier]))
      this.shadowRoot.querySelector('#components-version')?.setAttribute('vars', JSON.stringify([this.versions.components ?? '?.?.?']))
      this.shadowRoot.querySelector('#script-version')?.setAttribute('vars', JSON.stringify([this.versions.trcadScript ?? '?.?.?']))
      this.shadowRoot.querySelector('#trcad-version')?.setAttribute('vars', JSON.stringify([this.versions.trcad ?? '?.?.?']))
    }
  }
  async connectedCallback(){
    useShadow(this)
    await useShadowStyle(this, styleText, './as-footer.css')
    // The integration env can resolve after first paint — e.g. GrabCAD env is
    // detected asynchronously once userData loads (as-app.ts's connectedCallback,
    // via host.ts's resolveSessionEnv), which sets internalData.appEnv.
    // Re-render so the GC marker stays in sync.
    this.removeEnvEffect = internalData.subscribeKey('appEnv', () => this.redraw())
    await this.getVersions()
    this.redraw()
  }
  disconnectedCallback(){
    this.removeEnvEffect?.()
    this.removeEnvEffect = undefined
  }
}

export class AsFooter extends HTMLElement{
  static readonly tag = 'as-footer' as const;

  get html(){
    return /*html*/`
      <as-version-tag></as-version-tag>
      <as-trinckle-label></as-trinckle-label>
  `
  }
  async connectedCallback(){
    useShadow(this)
    await useShadowStyle(this, styleText, './as-footer.css')
  }
}

customElements.define(AsVersionTag.tag, AsVersionTag)
customElements.define(AsFooter.tag, AsFooter)